export default {
  default: '',
  loading: 'loading',
  success: 'success',
  failed: 'failed',
};
